const API_BASE = import.meta.env.VITE_API_URL ?? "";

const toAbsoluteApiUrl = (path: string) => {
  if (!API_BASE) return path;
  const normalizedBase = API_BASE.endsWith("/")
    ? API_BASE.slice(0, -1)
    : API_BASE;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${normalizedBase}${normalizedPath}`;
};

export const resolveAvatarUrl = (value?: string | null) => {
  const raw = String(value ?? "").trim();

  if (!raw) return undefined;
  if (raw.startsWith("data:image/")) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("//")) return `https:${raw}`;
  if (raw.startsWith("/")) return toAbsoluteApiUrl(raw);

  return raw;
};

export const buildFallbackAvatarUrl = (name?: string) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(
    name || "Professeur",
  )}&background=ede9fe&color=4c1d95&size=800`;
